import { api } from "@/api";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { Compra } from "@/shared/types/compra";
import { sleep } from "@/shared/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";

export interface CompraRequest {
    proveedorId: string;
    numComprobante: string;
    depositoId?: string;
    fecha?: string;
    credito?: boolean;
    items: CompraItemRequest[]
}

export interface CompraItemRequest {
    articuloId: string;
    cantidad: number;
    costoUnitario?: number;
}

export async function addCompra(request: CompraRequest): Promise<Compra> {
    await sleep(1000);
    const response = await api.post("compras", request);
    return response.data;
}

export function useAddCompraMutation(mutationConfig: MutationConfig<Compra, CompraRequest> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: addCompra,
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["compras"] });
        },
    })
}

export interface AddCompraMutationProps {
    mutationConfig?: MutationConfig<Compra, CompraRequest>
    children?: (mutationResult: MutationResult<Compra, CompraRequest>) => ReactNode
}

export function AddCompraMutation({
    mutationConfig,
    children
}: AddCompraMutationProps) {
    const mutationResult = useAddCompraMutation(mutationConfig);
    return children && children(mutationResult);
}